import type { CSSProperties, ReactNode } from 'react';

export const BadgeIndicatorThemeName = {
	Blue: 'blue',
	Green: 'green',
	Grey: 'grey',
	Pink: 'pink',
	Purple: 'purple',
	Red: 'red',
	Yellow: 'yellow'
} as const;

export type BadgeIndicatorThemeName =
	(typeof BadgeIndicatorThemeName)[keyof typeof BadgeIndicatorThemeName];

export const BadgeIndicatorVariant = {
	Outline: 'outline',
	Soft: 'soft',
	Solid: 'solid'
} as const;

export type BadgeIndicatorVariant =
	(typeof BadgeIndicatorVariant)[keyof typeof BadgeIndicatorVariant];

export const BadgeIndicatorSize = {
	Default: 'default',
	Small: 'small'
} as const;

export type BadgeIndicatorSize =
	(typeof BadgeIndicatorSize)[keyof typeof BadgeIndicatorSize];

export type BadgeIndicatorColorScheme = {
	accent: string;
	background: string;
	border: string;
	foreground: string;
	gradientA: string;
	gradientB: string;
	gradientC: string;
	shimmer: string;
};

export type BadgeIndicatorThemeConfig = {
	border: string;
	foreground: string;
	softBackground: string;
	solidBackground: string;
	solidForeground: string;
};

export type BadgeIndicatorCssVars = CSSProperties &
	Record<`--ab-${string}`, string | number>;

export type BadgeIndicatorProps = {
	label: ReactNode;
	size?: BadgeIndicatorSize;
	theme: BadgeIndicatorThemeName;
	variant?: BadgeIndicatorVariant;
};
